module.exports = __webpack_public_path__ + "static/media/reglamento_2.cf2d0621.png";